var React = require('react');

function Umbrella (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"0","strokeWidth":"4","strokeLinecap":"round","fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M91.903 43.5C85.76 33.1 73.473 26 60.528 26 39.8 26.005 23 42.85 23 63.63A46.582 46.582 0 0024.14 73s2.292-5.402 12.288-6.159c0 0 6.143-8.921 21.467-9.493 0 0 9.066-9.678 21.94-9.168 0 0 5.065-5.155 12.165-4.399l-.097-.281zM52 27s15.004.492 27 21M40 32s-10.381 11.126-3.833 34","key":0}),React.createElement("path",{"d":"M44 26l26.55 62.393.096.245a4.6 4.6 0 01-2.244 5.91A4.562 4.562 0 0162.41 92.6l-1.614-3.794","key":1})]));
}

Umbrella.defaultProps = {"width":"114","height":"114"};

module.exports = Umbrella;

Umbrella.default = Umbrella;
